import { GetterTree } from "vuex";
import { PROVEED } from "./types";
import { RootState } from "@/store/modules/general/types";

type AuthGetterTree = GetterTree<PROVEED, RootState>;

export const getters: AuthGetterTree = {
  
};
